import { render, staticRenderFns } from "./ApprovalLevel2.vue?vue&type=template&id=84d968d0"
import script from "./ApprovalLevel2.vue?vue&type=script&lang=js"
export * from "./ApprovalLevel2.vue?vue&type=script&lang=js"
import style0 from "./ApprovalLevel2.vue?vue&type=style&index=0&id=84d968d0&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports